<template>
  <div v-element-loader="{ endpoint: 'order' }">
    <div class="my-pages__content-grid rate-limiting__top-grid">
      <div class="input-column">
        <div>
          <h2 v-epi-edit="'RateLimitingHeading'" class="my-pages__page-type-header">
            {{ t('rateLimitingHeading') }}
          </h2>
        </div>
      </div>
    </div>

    <div>
      <oie-message-box class="message-box--orange message-box--compact rate-limiting-message">
        <svg
          v-if="mq('small')"
          width="22px"
          height="22px"
          viewBox="0 0 32 33"
          aria-labelledby=""
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          class="message-bar__icon svg">
          <title id="" lang="sv"> icon</title>
          <g fill="currentColor" fill-rule="evenodd" class="svg__color"><path d="M21 24.49H11v-3.143h3.333v-4.714h-1.666V13.49H16c.922 0 1.667.704 1.667 1.571v6.286H21v3.143zm-5-17a2 2 0 1 1-.001 4.001A2 2 0 0 1 16 7.49zm0-7c-8.822 0-16 7.179-16 16 0 8.824 7.178 16 16 16s16-7.176 16-16c0-8.821-7.178-16-16-16z" fill-rule="evenodd" /></g>
        </svg>
        {{ t('rateLimitingDescription') }}
      </oie-message-box>
    </div>

    <div>
      <oie-recaptcha-v2 v-model="recaptchaResponse"></oie-recaptcha-v2>
    </div>
  </div>
</template>

<script>
import httpService from '@/core/http-service'

export default {
  data: () => ({
    recaptchaResponse: null
  }),
  watch: {
    recaptchaResponse(response) {
      if (!response) return

      httpService.post('rate-limiting/captcha-check', { recaptchaResponse: this.recaptchaResponse }).then((res) => {
        if (res.data.isValid) {
          window.location = '/'
        }
      })
    }
  }
}
</script>

<style lang="scss">

  .rate-limiting__top-grid {
    margin-bottom: 1.875rem;
  }

  .rate-limiting-status-heading {
    margin-top: 2.5rem;
    margin-bottom: 0.5rem;
  }

  .rate-limiting-message {
    margin-bottom: 1.25rem;
  }

</style>
